<template>
  <div class="big-screen-container" :style="containerStyle">
    <img src="../assets/images/home_bg.png" class="home_img rotating-bg"
      style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);" />
    <div class="big-screen-header"></div>
    <div class="big-screen-content">
      <div class="big-screen-content-left">
        <TalentTotalPanel :dataList="talentList"  />
        <HighLevelTalentPanel  :dataObject="talentObject" />
      </div>
      <div class="big-screen-content-center">
        <div class="big-screen-content-center-map-wrap">
          <HomeMap />
        </div>
      </div>
      <div class="big-screen-content-right">
        <GraduatePanel :dataObject="graduatePaneData"  />
        <RecruitCalendar :dataObject="recruitCalendarData" />
      </div>
      <div class="big-screen-content-center-title-list">
        <div v-for="item in subIndexList" class="big-screen-content-center-title" @click="btnClick(item)"
          style="cursor:pointer;">
          <img src="../assets/images/btn_1.png" alt="象山重点产业图谱" />
          {{ item.configName }}
        </div>
      </div>
    </div>
    <div class="big-screen-footer">
      <div class="big-screen-footer-inner">
        备案信息：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: white;">浙ICP备2025200610号-1</a>
      </div>
    </div>
    <ComingSoonModal :visible="showComingSoonModal" @close="showComingSoonModal = false" />
  </div>
</template>

<script>
import TalentTotalPanel from '../components/TalentTotalPanel.vue'
import HighLevelTalentPanel from '../components/HighLevelTalentPanel.vue'
import GraduatePanel from '../components/GraduatePanel.vue'
import RecruitCalendar from '../components/RecruitCalendar.vue'
import ChinaMap from '../components/ChinaMap.vue'
import SvgMapWithPopup from '../components/SvgMapWithPopup.vue'
import XiangshanMap from '../components/XiangshanMap.vue'
import HomeMap from '../components/HomeMap.vue'
import ComingSoonModal from '../components/ComingSoonModal.vue'

import rencai1 from '../assets/images/rencai_1.png'
import rencai2 from '../assets/images/rencai_2.png'
import rencai3 from '../assets/images/rencai_3.png'
import rencai4 from '../assets/images/rencai_4.png'
import rencai5 from '../assets/images/rencai_5.png'
import rencai6 from '../assets/images/rencai_6.png'
import { talentApi } from '../api/talent'
import autofit from 'autofit.js'

export default {
  name: 'BigScreenLayout',
  components: { TalentTotalPanel, HighLevelTalentPanel, GraduatePanel, RecruitCalendar, ChinaMap, SvgMapWithPopup, XiangshanMap, HomeMap, ComingSoonModal },
  data() {
    return {
      talentList: [],
      talentObject: {},
      graduatePaneData: {},
      recruitCalendarData: {},
      subIndexList: [],
      showComingSoonModal: false
    }
  },
  mounted() {
    autofit.init({
      fast: true,
      width: 1920,
      height: 1080,
      renderDom:'#app',
    },true)
    this.fetchData()
    this.getIndex()
  },
  methods: {
    btnClick(item) {
      if (item.configName == '象山县产业引才场图') {
        this.$router.push({ path: '/clean-energy-talent-map' })
      }
      if (item.configName == '象山产业引才高校图谱') {

        this.$router.push({ path: '/industry-talent-map', query: { id: item.indexId, name: item.configName } });
      }
      if (item.configName == '象山产业人才结构图谱') {
        // this.showComingSoonModal = true;
        this.$router.push('/xiangshan-talent-structure')
      }
    },
    async fetchData() {
      const data = await talentApi.getIndexDetail()
      const talentData = data.find(item => item.configName === '人才总量')
      if (talentData && talentData.children) {
        this.talentList = talentData.children.map(item => ({
          type: item.configBelong.toUpperCase(),
          name: item.configName,
          value: parseInt(item.configValue) || 0,
          color: "#4d8aff",
          bg: this.getTalentBg(item.configBelong.toUpperCase()),
        }))
      }
      this.talentObject = data.find(item => item.configName === '高层次人才')
      this.graduatePaneData = data.find(item => item.configName === '高教毕业生')
      this.recruitCalendarData = data.find(item => item.configName === '招聘月历')
    },
    async getIndex() {
      talentApi.getSubIndexList().then(res => {
        this.subIndexList = res
        console.log("res", res)

      })
    },
    getTalentBg(name) {
      if (name === "A") {
        return `url(${rencai1})`
      }
      if (name === "B") {
        return `url(${rencai2})`
      }
      if (name === "C") {
        return `url(${rencai3})`
      }
      if (name === "D") {
        return `url(${rencai4})`
      }
      if (name === "E") {
        return `url(${rencai5})`
      }
      if (name === "F") {
        return `url(${rencai6})`
      }
    }
  }

}
</script>

<style scoped>
.big-screen-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-image: url('../assets/images/big-screen-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.big-screen-content-center {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.big-screen-content-center-map-wrap {
  flex: 1;
  min-width: 0;
  min-height: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 100px;
  box-sizing: border-box;
}

.big-screen-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-image: url('../assets/images/big-screen-header.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 70px;
}

.big-screen-content-center-title-list {
  position: absolute;
  left: 50%;
  bottom: 160px;
  transform: translateX(-50%);
  z-index: 8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 20px;
  pointer-events: none;
}

.big-screen-content-center-title-list .big-screen-content-center-title {
  pointer-events: auto;
}

.big-screen-content-left {
  position: relative;
  z-index: 12;
  width: 26%;
  height: 100%;
  padding-bottom: 70px;
  padding-left: 20px;
}

.big-screen-content-right {
  position: relative;
  z-index: 12;
  width: 26%;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
}

.big-screen-content {
  width: 100%;
  display: flex;
  height: 100%;
  padding-top: 70px;
  padding-bottom: 70px;
  flex-direction: row;
  position: relative;
}

.big-screen-content-center-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  margin-left: 20px;
  margin-top: 20px;
  width: 200px;
  background-image: url('../assets/images/btn_bg_1.png');
  background-size: cover;
  background-position: center;
  margin-bottom: 70px;
  background-repeat: no-repeat;
}

.big-screen-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('../assets/images/big-screen-footer.png');
  background-size: cover;
  background-position: center;
  z-index: 99;
  background-repeat: no-repeat;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.big-screen-footer-inner {
  pointer-events: auto;
  cursor: pointer;
  font-size: 16px;
  line-height: 70px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  max-width: 100%;
  padding: 0 12px;
}

@keyframes rotate360 {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.rotating-bg {
  animation: rotate360 20s linear infinite;
}

</style>
